// tslint:disable
/* MACLE TypeScript 10/01/2026 17:44:40 */
import { BaseData, BaseDataDisplay, EFilterBool, EGenero, EFaixaEtaria, ETipoFrete, ESexo, DataEndereco, EStatusPedidoSite, EArredondPrc } from './maf.vo';
import { ArrayList } from 'maf-web';

export class PKContaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKContaAPP";
  codEmpresa: number = 0;
  codConta: number = 0;

  constructor()
  constructor(codEmpresa: number, codConta: number)
  constructor(codEmpresa?: number, codConta?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codConta = codConta || 0;
  }

  public getPK(): PKContaAPP {
    return new PKContaAPP(this.codEmpresa, this.codConta);
  }

  public equals(arg: PKContaAPP): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codConta === this.codConta)
    ;
  }
}


export class DataContaAPP extends PKContaAPP {
  readonly jclass: string = "com.macle.app.vo.DataContaAPP";
  descricao: string = "";
  idSeller: string = "";
  codLoja: number = 0;
}


export class DataPedidoClienteDocumentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoML";
  value: string = "";
  id: string = "";
}


export class DataPedidoClienteDocumentoAdicionalML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoAdicionalML";
  value: string = "";
  type: string = "";
}


export class DataEnderecoAuxML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoAuxML";
  name: string = "";
  id: string = "";
}


export class DataEnderecoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoML";
  city: DataEnderecoAuxML = new DataEnderecoAuxML();
  street_name: string = "";
  street_number: string = "";
  zip_code: string = "";
  neighborhood: DataEnderecoAuxML = new DataEnderecoAuxML();
  receiver_name: string = "";
  state: DataEnderecoAuxML = new DataEnderecoAuxML();
  country: DataEnderecoAuxML = new DataEnderecoAuxML();
  comment: string = "";
}


export class DataPedidoClienteReceiverML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteReceiverML";
  document: DataPedidoClienteDocumentoML = new DataPedidoClienteDocumentoML();
  additional_documents: ArrayList<DataPedidoClienteDocumentoAdicionalML> = new ArrayList<DataPedidoClienteDocumentoAdicionalML>(DataPedidoClienteDocumentoAdicionalML);
  billing_address: DataEnderecoML = new DataEnderecoML();
  city_ibge: string = "";
  name: string = "";
  id: number = 0;
}


export class DataPedidoClienteML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteML";
  receiver: DataPedidoClienteReceiverML = new DataPedidoClienteReceiverML();
}


export enum EFormaPagamentoAPP {
  NONE = 0,
  BOLETO = 1,
  CARTAO = 2,
  CREDIARIO = 3,
  CONDICIONAL = 4,
  PIX = 5,
  MARKETPLACE = 6,
}

export namespace EFormaPagamentoAPP {
  export function toDisplay(arg: EFormaPagamentoAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Boleto";
      case 2: return "Cart&atilde;o";
      case 3: return "Credi&aacute;rio";
      case 4: return "Condicional";
      case 5: return "PIX";
      case 6: return "Marketplace";
      default: return "";
    }
  }

  export function enums(): EFormaPagamentoAPP[] {
    return [EFormaPagamentoAPP.NONE,EFormaPagamentoAPP.BOLETO,EFormaPagamentoAPP.CARTAO,EFormaPagamentoAPP.CREDIARIO,EFormaPagamentoAPP.CONDICIONAL,EFormaPagamentoAPP.PIX,EFormaPagamentoAPP.MARKETPLACE];
  }
}


export class FilterPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.FilterPedidoVit";
  cnpj: string = "";
  dataFim: string = "";
  dataIni: string = "";
  enviadoSistema: EFilterBool = EFilterBool.NONE;
}


export enum ETipoFreteAPP {
  NONE = 0,
  SEDEX = 1,
  PAC = 2,
  ENVIO_FLEX_ML = 3,
}

export namespace ETipoFreteAPP {
  export function toDisplay(arg: ETipoFreteAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Sedex";
      case 2: return "PAC";
      case 3: return "Envio Flex";
      default: return "";
    }
  }

  export function enums(): ETipoFreteAPP[] {
    return [ETipoFreteAPP.NONE,ETipoFreteAPP.SEDEX,ETipoFreteAPP.PAC,ETipoFreteAPP.ENVIO_FLEX_ML];
  }
}


export class DataFreteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteAPP";
  prazoEntrega: string = "";
  indisponivel: boolean = false;
  valorFrete: number = 0;
  tipoFrete: ETipoFreteAPP = ETipoFreteAPP.NONE;
}


export class DataFreteVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteVitrinePubAPP";
  codClienteMacle: number = 0;
  nomeLoja: string = "";
  frete: ArrayList<DataFreteAPP> = new ArrayList<DataFreteAPP>(DataFreteAPP);
}


export class DataPedidoCompradorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCompradorML";
  nickname: string = "";
  id: number = 0;
}


export class DataPedidoEntregaLimiteEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaLimiteEnvioML";
  date: string = "";
}


export class DataPedidoEntregaOpcaoEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaOpcaoEnvioML";
  estimated_delivery_limit: DataPedidoEntregaLimiteEnvioML = new DataPedidoEntregaLimiteEnvioML();
}


export class DataPedidoEntregaML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaML";
  receiver_address: DataEnderecoML = new DataEnderecoML();
  tracking_method: string = "";
  shipping_option: DataPedidoEntregaOpcaoEnvioML = new DataPedidoEntregaOpcaoEnvioML();
  logistic_type: string = "";
  sender_id: number = 0;
  receiver_id: number = 0;
  base_cost: number = 0;
  tracking_number: string = "";
}


export class DataPedidoPagamentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPagamentoML";
  status: any;
  total_paid_amount: number = 0;
  transaction_amount: number = 0;
  payment_method_id: string = "";
  reason: string = "";
  date_created: string = "";
  installments: number = 0;
  order_id: number = 0;
  payer_id: number = 0;
  transaction_amount_refunded: number = 0;
  id: number = 0;
}


export class DataPedidoShippingML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoShippingML";
  id: number = 0;
}


export class DataPedidoItemVariacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVariacaoML";
  value_id: string = "";
  value_name: string = "";
  name: string = "";
  id: string = "";
}


export class DataPedidoItemDadosML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemDadosML";
  variation_attributes: ArrayList<DataPedidoItemVariacaoML> = new ArrayList<DataPedidoItemVariacaoML>(DataPedidoItemVariacaoML);
  title: string = "";
  category_id: string = "";
  variation_id: number = 0;
  seller_sku: string = "";
  warranty: string = "";
  id: string = "";
}


export class DataPedidoItemML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemML";
  quantity: number = 0;
  listing_type_id: string = "";
  sale_fee: number = 0;
  full_unit_price: number = 0;
  unit_price: number = 0;
  item: DataPedidoItemDadosML = new DataPedidoItemDadosML();
}


export class DataPedidoMediadorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoMediadorML";
  id: number = 0;
}


export class DataPedidoResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoResultML";
  cliente: DataPedidoClienteML = new DataPedidoClienteML();
  status: any;
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  pack_id: number = 0;
  seller: DataPedidoCompradorML = new DataPedidoCompradorML();
  entrega: DataPedidoEntregaML = new DataPedidoEntregaML();
  date_created: string = "";
  last_updated: string = "";
  payments: ArrayList<DataPedidoPagamentoML> = new ArrayList<DataPedidoPagamentoML>(DataPedidoPagamentoML);
  shipping: DataPedidoShippingML = new DataPedidoShippingML();
  total_amount: number = 0;
  expiration_date: string = "";
  date_closed: string = "";
  paid_amount: number = 0;
  order_items: ArrayList<DataPedidoItemML> = new ArrayList<DataPedidoItemML>(DataPedidoItemML);
  mediations: ArrayList<DataPedidoMediadorML> = new ArrayList<DataPedidoMediadorML>(DataPedidoMediadorML);
  date_last_updated: string = "";
  id: number = 0;
}


export class DataPedidoPaginacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPaginacaoML";
  total: number = 0;
  limit: number = 0;
  offset: number = 0;
}


export class DataPedidoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoML";
  display: string = "";
  results: ArrayList<DataPedidoResultML> = new ArrayList<DataPedidoResultML>(DataPedidoResultML);
  paging: DataPedidoPaginacaoML = new DataPedidoPaginacaoML();
  query: string = "";
}


export class LVPedStatsBrowser extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsBrowser";
  browser: string = "";
  browserType: string = "";
  versaoBrowser: string = "";
}


export enum ETipoConfirmacaoConsumidorSiteAPP {
  NONE = 0,
  SMS = 1,
  EMAIL = 2,
}

export namespace ETipoConfirmacaoConsumidorSiteAPP {
  export function toDisplay(arg: ETipoConfirmacaoConsumidorSiteAPP): string {
    switch (arg) {
      case 0: return "Nenhum";
      case 1: return "SMS";
      case 2: return "EMAIL";
      default: return "";
    }
  }

  export function enums(): ETipoConfirmacaoConsumidorSiteAPP[] {
    return [ETipoConfirmacaoConsumidorSiteAPP.NONE,ETipoConfirmacaoConsumidorSiteAPP.SMS,ETipoConfirmacaoConsumidorSiteAPP.EMAIL];
  }
}


export class LVPKPedido extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKPedido";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): LVPKPedido {
    return new LVPKPedido(this.codPedido);
  }

  public equals(arg: LVPKPedido): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export enum EStatusPedido {
  NONE = 0,
  PRECONFPAGTO = 7,
  CONFERENCIAPAGTO = 1,
  EMANALISE = 10,
  APROVADO = 6,
  REPROVADO = 8,
  EXPEDICAO = 2,
  EMBARQUE = 3,
  ENTREGUE = 4,
  CANCELADO = 5,
  DEVOLUCAO = 9,
  CONTESTADO = 11,
  NAOFINALIZADO = 12,
}

export namespace EStatusPedido {
  export function toDisplay(arg: EStatusPedido): string {
    switch (arg) {
      case 0: return "";
      case 7: return "";
      case 1: return "Confirma&amp;ccedil;&amp;atilde;o de pagamento";
      case 10: return "Pedido em an&amp;aacute;lise";
      case 6: return "Pedido aprovado";
      case 8: return "Pedido reprovado";
      case 2: return "Preparado para envio";
      case 3: return "Pedido em transporte";
      case 4: return "Pedido entregue";
      case 5: return "Pedido cancelado";
      case 9: return "Pedido devolvido";
      case 11: return "Contestado";
      case 12: return "Pedido nao Finalizado";
      default: return "";
    }
  }

  export function enums(): EStatusPedido[] {
    return [EStatusPedido.NONE,EStatusPedido.PRECONFPAGTO,EStatusPedido.CONFERENCIAPAGTO,EStatusPedido.EMANALISE,EStatusPedido.APROVADO,EStatusPedido.REPROVADO,EStatusPedido.EXPEDICAO,EStatusPedido.EMBARQUE,EStatusPedido.ENTREGUE,EStatusPedido.CANCELADO,EStatusPedido.DEVOLUCAO,EStatusPedido.CONTESTADO,EStatusPedido.NAOFINALIZADO];
  }
}


export enum EFormaPagto {
  NONE = 0,
  VISA = 1,
  MASTERCAR = 2,
  DINNERS = 3,
  AMERICANEXPRESS = 4,
  HIPERCARD = 5,
  BANCO_BRADESCO = 6,
  BANCO_BRASIL = 7,
  BANCO_ITAU = 8,
  BOLETO = 9,
  AMERICANEXPRESS_PAGSEGURO = 10,
  HIPERCARD_PAGSEGURO = 11,
  ITAU_PAGSEGURO = 12,
  BRADESCO_PAGSEGURO = 13,
  UNIBANCO_PAGSEGURO = 14,
  BANCOREAL_PAGSEGURO = 15,
  AURA_PAGSEGURO = 16,
  BANCOBRASIL_PAGSEGURO = 17,
  ELO = 18,
}

export namespace EFormaPagto {
  export function toDisplay(arg: EFormaPagto): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Cart&amp;atilde;o Visa";
      case 2: return "Cart&amp;atilde;o MasterCard";
      case 3: return "Cart&amp;atilde;o Dinners";
      case 4: return "Cart&amp;atilde;o American Express";
      case 5: return "Cart&amp;atilde;o Hipercard";
      case 6: return "Banco Bradesco";
      case 7: return "Banco do Brasil";
      case 8: return "Banco Ita&amp;uacute;";
      case 9: return "Boleto";
      case 10: return "American Express - Pag Seguro";
      case 11: return "Hipercard - Pag Seguro";
      case 12: return "Ita&amp;uacute; - Pag Seguro";
      case 13: return "Bradesco - Pag Seguro";
      case 14: return "Unibanco - Pag Seguro";
      case 15: return "Banco Real - Pag Seguro";
      case 16: return "Aura - Pag Seguro";
      case 17: return "Banco do Brasil - Pag Seguro";
      case 18: return "Elo";
      default: return "";
    }
  }

  export function enums(): EFormaPagto[] {
    return [EFormaPagto.NONE,EFormaPagto.VISA,EFormaPagto.MASTERCAR,EFormaPagto.DINNERS,EFormaPagto.AMERICANEXPRESS,EFormaPagto.HIPERCARD,EFormaPagto.BANCO_BRADESCO,EFormaPagto.BANCO_BRASIL,EFormaPagto.BANCO_ITAU,EFormaPagto.BOLETO,EFormaPagto.AMERICANEXPRESS_PAGSEGURO,EFormaPagto.HIPERCARD_PAGSEGURO,EFormaPagto.ITAU_PAGSEGURO,EFormaPagto.BRADESCO_PAGSEGURO,EFormaPagto.UNIBANCO_PAGSEGURO,EFormaPagto.BANCOREAL_PAGSEGURO,EFormaPagto.AURA_PAGSEGURO,EFormaPagto.BANCOBRASIL_PAGSEGURO,EFormaPagto.ELO];
  }
}


export class LVDataTransacaoCieloResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoCieloResult";
  mensagemAutorisacao: string = "";
  parcelasFormaPagto: number = 0;
  statusAutorizacao: number = 0;
  codPedidoTransacao: number = 0;
  bandeiraTransacao: EFormaPagto = EFormaPagto.NONE;
  produtoFormaPagto: string = "";
  arpAutorisacao: string = "";
  horaTransacao: string = "";
  valorTransacao: number = 0;
  mensagemCaptura: string = "";
  tidTransacao: string = "";
  codigoCaptura: number = 0;
  statusTransacao: number = 0;
  nsuAutorisacao: string = "";
  lrAutorisacao: string = "";
  dataTransacao: string = "";
  panTransacao: string = "";
}


export class LVPedEndereco extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedEndereco";
  endereco: string = "";
  cidade: string = "";
  bairro: string = "";
  CEP: number = 0;
  numero: string = "";
  estado: string = "";
  descricaoEndereco: string = "";
  retirarLoja: boolean = false;
  infReferencia: string = "";
}


export class LVDataTransacaoRedecardResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoRedecardResult";
  descricao: string = "";
  pedido: LVPKPedido = new LVPKPedido();
  codConfirmacaoAutomatica: number = 0;
  descricaoRetorno: string = "";
  codRetorno: number = 0;
  nroAutorizacao: number = 0;
  nroSeqUnico: string = "";
  nroAutenticacao: string = "";
  nsuAutorizacao: string = "";
  codPaisEmissor: string = "";
  data: string = "";
}


export class LVPKVendedor extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKVendedor";
  codEmpresa: number = 0;
  codFuncionario: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): LVPKVendedor {
    return new LVPKVendedor(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: LVPKVendedor): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codFuncionario === this.codFuncionario)
    ;
  }
}


export enum ETipoPagto {
  NONE = 0,
  PAGSYS = 1,
  PAGSEGURO = 2,
  CIELO = 3,
  ITAU = 4,
  REDECARD = 5,
}

export namespace ETipoPagto {
  export function toDisplay(arg: ETipoPagto): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagsys";
      case 2: return "Pag Seguro";
      case 3: return "Cielo";
      case 4: return "Itau";
      case 5: return "Redecard";
      default: return "";
    }
  }

  export function enums(): ETipoPagto[] {
    return [ETipoPagto.NONE,ETipoPagto.PAGSYS,ETipoPagto.PAGSEGURO,ETipoPagto.CIELO,ETipoPagto.ITAU,ETipoPagto.REDECARD];
  }
}


export class LVPKClienteSite extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKClienteSite";
  codCliente: number = 0;
  codDependente: number = 0;
  codSite: number = 0;
  codEmpCli: number = 0;

  constructor()
  constructor(codSite: number, codEmpCli: number, codCliente: number, codDependente: number)
  constructor(codSite?: number, codEmpCli?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codSite = codSite || 0;
    this.codEmpCli = codEmpCli || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): LVPKClienteSite {
    return new LVPKClienteSite(this.codSite, this.codEmpCli, this.codCliente, this.codDependente);
  }

  public equals(arg: LVPKClienteSite): boolean {
    return arg 
        && (arg.codCliente === this.codCliente)
        && (arg.codDependente === this.codDependente)
        && (arg.codSite === this.codSite)
        && (arg.codEmpCli === this.codEmpCli)
    ;
  }
}


export class LVDataVendedor extends LVPKVendedor {
  readonly jclass: string = "com.macle.site.vo.LVDataVendedor";
  nome: string = "";
  listPed: ArrayList<LVPKPedido> = new ArrayList<LVPKPedido>(LVPKPedido);
  nickName: string = "";
}


export class LVPedCliente extends LVPKClienteSite {
  readonly jclass: string = "com.macle.site.vo.LVPedCliente";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  dataNascimento: string = "";
  CPF: string = "";
  senha: string = "";
  nomeCli: string = "";
  enderecoCobranca: LVPedEndereco = new LVPedEndereco();
  vendedor: LVDataVendedor = new LVDataVendedor();
  enderecoEntrega: LVPedEndereco = new LVPedEndereco();
  telCelular: string = "";
  telResidencial: string = "";
}


export class BaseTransp extends BaseData {
  readonly jclass: string = "com.macle.site.vo.BaseTransp";
  codLOG: number = 0;

  constructor()
  constructor(codLOG: number)
  constructor(codLOG?: number) {
    super();
    this.codLOG = codLOG || 0;
  }

  public getPK(): BaseTransp {
    return new BaseTransp(this.codLOG);
  }

  public equals(arg: BaseTransp): boolean {
    return arg 
        && (arg.codLOG === this.codLOG)
    ;
  }
}


export class LVPKItem extends BaseTransp {
  readonly jclass: string = "com.macle.site.vo.LVPKItem";
  codItem: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codLOG: number, codEmpresa: number, codItem: number)
  constructor(codLOG?: number, codEmpresa?: number, codItem?: number) {
    super();
    this.codLOG = codLOG || 0;
    this.codEmpresa = codEmpresa || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): LVPKItem {
    return new LVPKItem(this.codLOG, this.codEmpresa, this.codItem);
  }

  public equals(arg: LVPKItem): boolean {
    return arg && super.equals(arg)
        && (arg.codItem === this.codItem)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class LVCorItem extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVCorItem";
  codItem: LVPKItem = new LVPKItem();
  descCor: string = "";
  codCor: number = 0;
}


export class LVDataTamanho extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTamanho";
  codTamanho: number = 0;
  ordem: number = 0;
  EAN: string = "";
  descTamanho: string = "";
  qtdEstoque: number = 0;
}


export class LVPedItem extends LVPKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedItem";
  codItem: LVPKItem = new LVPKItem();
  descricao: string = "";
  qtd: number = 0;
  cor: LVCorItem = new LVCorItem();
  embalar: boolean = false;
  tamanho: LVDataTamanho = new LVDataTamanho();
  precoUnit: number = 0;
}


export class LVPedStatsSO extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsSO";
  SO: string = "";
}


export class LVPedStats extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStats";
  browser: LVPedStatsBrowser = new LVPedStatsBrowser();
  SO: LVPedStatsSO = new LVPedStatsSO();
  ipCliente: string = "";
}


export class LVPedFormaPagto extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFormaPagto";
  nome: string = "";
  formaPagamento: EFormaPagto = EFormaPagto.NONE;
  valMes: string = "";
  valAno: string = "";
  numCartao: string = "";
  nroParcelas: number = 0;
  codSeguranca: string = "";
}


export class LVPedFrete extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFrete";
  prazoEntrega: string = "";
  valorFrete: number = 0;
  tipoFrete: ETipoFrete = ETipoFrete.NONE;
  CEP: number = 0;
  nroObjetoPac: string = "";
}


export class LVPedido extends LVPKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedido";
  enviadoSistema: boolean = false;
  hora: string = "";
  status: EStatusPedido = EStatusPedido.NONE;
  pedTransacaoCielo: LVDataTransacaoCieloResult = new LVDataTransacaoCieloResult();
  pedEnderecoComprador: LVPedEndereco = new LVPedEndereco();
  pedTransacaoRedecard: LVDataTransacaoRedecardResult = new LVDataTransacaoRedecardResult();
  pedEnderecoEntrega: LVPedEndereco = new LVPedEndereco();
  vendedor: LVPKVendedor = new LVPKVendedor();
  tipoPagto: ETipoPagto = ETipoPagto.NONE;
  pedCliente: LVPedCliente = new LVPedCliente();
  listPedItem: ArrayList<LVPedItem> = new ArrayList<LVPedItem>(LVPedItem);
  pedStats: LVPedStats = new LVPedStats();
  pedFormaPagto: LVPedFormaPagto = new LVPedFormaPagto();
  pedidoFinalizado: boolean = false;
  pedFrete: LVPedFrete = new LVPedFrete();
  requestPedido: number = 0;
  data: string = "";
}


export class PKPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVit";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): PKPedidoVit {
    return new PKPedidoVit(this.codPedido);
  }

  public equals(arg: PKPedidoVit): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export class PKClienteMacleVitPub extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKClienteMacleVitPub";
  codClienteMacle: number = 0;
}


export class PKPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codPedido: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codPedido?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codPedido = codPedido || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKPedidoVitPub {
    return new PKPedidoVitPub(this.codPedido, this.clienteMacle);
  }

  public equals(arg: PKPedidoVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class DataEntregaDistanciaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaDistanciaAPP";
  duracaoViagemSegundos: number = 0;
  distanciaKM: number = 0;
  origem: string = "";
  destino: string = "";
}


export class DataPedidoEntregaVitPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVitPub";
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
}


export enum EOrdenacaoItem {
  NONE = 0,
  MAIS_RELEVANTE = 1,
  MENORES_PRECOS = 2,
  MAIORES_PRECOS = 3,
  MAIORES_DESCONTOS = 4,
}

export namespace EOrdenacaoItem {
  export function toDisplay(arg: EOrdenacaoItem): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Mais relevantes";
      case 2: return "Menores precos";
      case 3: return "Maiores precos";
      case 4: return "Maiores descontos";
      default: return "";
    }
  }

  export function enums(): EOrdenacaoItem[] {
    return [EOrdenacaoItem.NONE,EOrdenacaoItem.MAIS_RELEVANTE,EOrdenacaoItem.MENORES_PRECOS,EOrdenacaoItem.MAIORES_PRECOS,EOrdenacaoItem.MAIORES_DESCONTOS];
  }
}


export class PKItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemVit";
  codItemVit: number = 0;

  constructor()
  constructor(codItemVit: number)
  constructor(codItemVit?: number) {
    super();
    this.codItemVit = codItemVit || 0;
  }

  public getPK(): PKItemVit {
    return new PKItemVit(this.codItemVit);
  }

  public equals(arg: PKItemVit): boolean {
    return arg 
        && (arg.codItemVit === this.codItemVit)
    ;
  }
}


export class PKItemLojaVitPub extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemLojaVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codItemVit: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codItemVit?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codItemVit = codItemVit || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKItemLojaVitPub {
    return new PKItemLojaVitPub(this.codItemVit, this.clienteMacle);
  }

  public equals(arg: PKItemLojaVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class PKVendaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKVendaVit";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaVit {
    return new PKVendaVit(this.codVenda);
  }

  public equals(arg: PKVendaVit): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class PKItemControleVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemControleVit";
  codItemControle: number = 0;
  codEmpresaControle: number = 0;

  constructor()
  constructor(codEmpresaControle: number, codItemControle: number)
  constructor(codEmpresaControle?: number, codItemControle?: number) {
    super();
    this.codEmpresaControle = codEmpresaControle || 0;
    this.codItemControle = codItemControle || 0;
  }

  public getPK(): PKItemControleVit {
    return new PKItemControleVit(this.codEmpresaControle, this.codItemControle);
  }

  public equals(arg: PKItemControleVit): boolean {
    return arg 
        && (arg.codItemControle === this.codItemControle)
        && (arg.codEmpresaControle === this.codEmpresaControle)
    ;
  }
}


export class PKTamanhoItemVit extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKTamanhoItemVit";
  codTamanho: number = 0;

  constructor()
  constructor(codItemVit: number, codTamanho: number)
  constructor(codItemVit?: number, codTamanho?: number) {
    super();
    this.codItemVit = codItemVit || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemVit {
    return new PKTamanhoItemVit(this.codItemVit, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemVit): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class DataVendaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVit";
  descricao: string = "";
  descricaoTamanho: string = "";
  qtd: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  desconto: number = 0;
  itemControle: PKItemControleVit = new PKItemControleVit();
  descricaoMarca: string = "";
  imgPequenoURL: string = "";
  descricaoCor: string = "";
  codCupomDesconto: number = 0;
  gtin: string = "";
  googleCategory: string = "";
  imgItemURL: string = "";
  item: PKTamanhoItemVit = new PKTamanhoItemVit();

  constructor()
  constructor(item: PKTamanhoItemVit, gtin: string, descricaoTamanho: string, itemControle: PKItemControleVit, descricao: string, googleCategory: string, descricaoCor: string, descricaoMarca: string, imgItemURL: string, qtd: number, precoUnitario: number, desconto: number, precoCongelado: boolean)
  constructor(item?: PKTamanhoItemVit, gtin?: string, descricaoTamanho?: string, itemControle?: PKItemControleVit, descricao?: string, googleCategory?: string, descricaoCor?: string, descricaoMarca?: string, imgItemURL?: string, qtd?: number, precoUnitario?: number, desconto?: number, precoCongelado?: boolean) {
    super();
    this.item = item ||  new PKTamanhoItemVit();
    this.gtin = gtin || "";
    this.descricaoTamanho = descricaoTamanho || "";
    this.itemControle = itemControle ||  new PKItemControleVit();
    this.descricao = descricao || "";
    this.googleCategory = googleCategory || "";
    this.descricaoCor = descricaoCor || "";
    this.descricaoMarca = descricaoMarca || "";
    this.imgItemURL = imgItemURL || "";
    this.qtd = qtd || 0;
    this.precoUnitario = precoUnitario || 0;
    this.desconto = desconto || 0;
    this.precoCongelado = precoCongelado || false;
  }

  public getPK(): DataVendaItemVit {
    return new DataVendaItemVit(this.item, this.gtin, this.descricaoTamanho, this.itemControle, this.descricao, this.googleCategory, this.descricaoCor, this.descricaoMarca, this.imgItemURL, this.qtd, this.precoUnitario, this.desconto, this.precoCongelado);
  }

  public equals(arg: DataVendaItemVit): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.descricaoTamanho === this.descricaoTamanho)
        && (arg.qtd === this.qtd)
        && (arg.precoUnitario === this.precoUnitario)
        && (arg.precoCongelado === this.precoCongelado)
        && (arg.desconto === this.desconto)
        && (arg.itemControle === this.itemControle)
        && (arg.descricaoMarca === this.descricaoMarca)
        && (arg.imgPequenoURL === this.imgPequenoURL)
        && (arg.descricaoCor === this.descricaoCor)
        && (arg.codCupomDesconto === this.codCupomDesconto)
        && (arg.gtin === this.gtin)
        && (arg.googleCategory === this.googleCategory)
        && (arg.imgItemURL === this.imgItemURL)
        && (arg.item === this.item)
    ;
  }
}


export class PKVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendedorAPP";
  codVendedor: number = 0;
  codEmpVendedor: number = 0;

  constructor()
  constructor(codEmpVendedor: number, codVendedor: number)
  constructor(codEmpVendedor?: number, codVendedor?: number) {
    super();
    this.codEmpVendedor = codEmpVendedor || 0;
    this.codVendedor = codVendedor || 0;
  }

  public getPK(): PKVendedorAPP {
    return new PKVendedorAPP(this.codEmpVendedor, this.codVendedor);
  }

  public equals(arg: PKVendedorAPP): boolean {
    return arg 
        && (arg.codVendedor === this.codVendedor)
        && (arg.codEmpVendedor === this.codEmpVendedor)
    ;
  }
}


export class PKPedidoCupomDesconto extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoCupomDesconto";
  codCupomDesconto: number = 0;

  constructor()
  constructor(codPedido: number, codCupomDesconto: number)
  constructor(codPedido?: number, codCupomDesconto?: number) {
    super();
    this.codPedido = codPedido || 0;
    this.codCupomDesconto = codCupomDesconto || 0;
  }

  public getPK(): PKPedidoCupomDesconto {
    return new PKPedidoCupomDesconto(this.codPedido, this.codCupomDesconto);
  }

  public equals(arg: PKPedidoCupomDesconto): boolean {
    return arg && super.equals(arg)
        && (arg.codCupomDesconto === this.codCupomDesconto)
    ;
  }
}


export enum EModoCreditoClienteVit {
  NONE = 0,
  VALOR = 1,
  PERCENT_ITEM = 2,
  PERCENT_VENDA = 3,
}

export namespace EModoCreditoClienteVit {
  export function toDisplay(arg: EModoCreditoClienteVit): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Valor";
      case 2: return "Percentual item";
      case 3: return "Percentual venda";
      default: return "";
    }
  }

  export function enums(): EModoCreditoClienteVit[] {
    return [EModoCreditoClienteVit.NONE,EModoCreditoClienteVit.VALOR,EModoCreditoClienteVit.PERCENT_ITEM,EModoCreditoClienteVit.PERCENT_VENDA];
  }
}


export class DataPedidoCupomDesconto extends PKPedidoCupomDesconto {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCupomDesconto";
  modo: EModoCreditoClienteVit = EModoCreditoClienteVit.NONE;
  valorPedido: number = 0;
  creditoCliente: boolean = false;
  valorCupom: number = 0;
  ID: string = "";
  item: PKTamanhoItemVit = new PKTamanhoItemVit();
  data: string = "";
}


export class DataVendaVit extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVit";
  hora: string = "";
  valor: number = 0;
  listItem: ArrayList<DataVendaItemVit> = new ArrayList<DataVendaItemVit>(DataVendaItemVit);
  codEmpresaVenda: number = 0;
  codVitrineVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  desconto: number = 0;
  precoTotalVenda: number = 0;
  qtdItensVenda: number = 0;
  listCupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
  data: string = "";
}


export enum EClasseItemSite {
  NONE = "''",
  NORMAL = "'N'",
  PROMOCAO = "'P'",
  LANCAMENTO = "'L'",
  DESTAQUE = "'D'",
  TODOS_SITE = "'TODOS_SITE'",
  FORA_SITE = "'FORA_SITE'",
}

export namespace EClasseItemSite {
  export function toDisplay(arg: EClasseItemSite): string {
    switch (arg) {
      case "''": return "";
      case "'N'": return "Normal";
      case "'P'": return "Promo&ccedil;&atilde;o";
      case "'L'": return "Lan&ccedil;amento";
      case "'D'": return "Destaque";
      case "'TODOS_SITE'": return "Todos do site";
      case "'FORA_SITE'": return "Fora do site";
      default: return "";
    }
  }

  export function enums(): EClasseItemSite[] {
    return [EClasseItemSite.NONE,EClasseItemSite.NORMAL,EClasseItemSite.PROMOCAO,EClasseItemSite.LANCAMENTO,EClasseItemSite.DESTAQUE,EClasseItemSite.TODOS_SITE,EClasseItemSite.FORA_SITE];
  }
}


export class FilterItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.FilterItemVit";
  descricao: string = "";
  codTamanho: number = 0;
  ativo: EFilterBool = EFilterBool.NONE;
  genero: EGenero = EGenero.NONE;
  ordenacao: EOrdenacaoItem = EOrdenacaoItem.NONE;
  hashtags: number[] = [];
  faixaEtaria: EFaixaEtaria = EFaixaEtaria.NONE;
  itemControle: PKItemControleVit = new PKItemControleVit();
  gtin: number = 0;
  ltipos: number[] = [];
  lmarcas: number[] = [];
  classeSite: EClasseItemSite = EClasseItemSite.NONE;
  precoMin: number = 0;
  precoMax: number = 0;
}


export class FiltroNodeItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeItemAPP";
  descricao: string = "";
  codigo: number = 0;
  quantidade: number = 0;
}


export class FiltroNodeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeAPP";
  nome: string = "";
  lista: ArrayList<FiltroNodeItemAPP> = new ArrayList<FiltroNodeItemAPP>(FiltroNodeItemAPP);
  display: string = "";
  visivel: boolean = false;
  value: number = 0;
}


export enum EVersaoIntegracaoPagarmeAPP {
  NONE = 0,
  V2 = 1,
  V5 = 2,
  V6 = 3,
}

export namespace EVersaoIntegracaoPagarmeAPP {
  export function toDisplay(arg: EVersaoIntegracaoPagarmeAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagar.me V2";
      case 2: return "Pagar.me V5";
      case 3: return "Zoop";
      default: return "";
    }
  }

  export function enums(): EVersaoIntegracaoPagarmeAPP[] {
    return [EVersaoIntegracaoPagarmeAPP.NONE,EVersaoIntegracaoPagarmeAPP.V2,EVersaoIntegracaoPagarmeAPP.V5,EVersaoIntegracaoPagarmeAPP.V6];
  }
}


export class PKParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKParcelaAPP";
  codEmpresaParcela: number = 0;
  codParcela: number = 0;

  constructor()
  constructor(codEmpresaParcela: number, codParcela: number)
  constructor(codEmpresaParcela?: number, codParcela?: number) {
    super();
    this.codEmpresaParcela = codEmpresaParcela || 0;
    this.codParcela = codParcela || 0;
  }

  public getPK(): PKParcelaAPP {
    return new PKParcelaAPP(this.codEmpresaParcela, this.codParcela);
  }

  public equals(arg: PKParcelaAPP): boolean {
    return arg 
        && (arg.codEmpresaParcela === this.codEmpresaParcela)
        && (arg.codParcela === this.codParcela)
    ;
  }
}


export class DataSendDadosEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendDadosEmissaoBoletoAPP";
  versaoEmissaoAPP: EVersaoIntegracaoPagarmeAPP = EVersaoIntegracaoPagarmeAPP.NONE;
  dadosEmissaoAPP: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class PKItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKItemAPP";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number)
  constructor(codEmpItem?: number, codItem?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): PKItemAPP {
    return new PKItemAPP(this.codEmpItem, this.codItem);
  }

  public equals(arg: PKItemAPP): boolean {
    return arg 
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export class PKTamanhoItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.PKTamanhoItemAPP";
  codTamanho: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, codTamanho: number)
  constructor(codEmpItem?: number, codItem?: number, codTamanho?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemAPP {
    return new PKTamanhoItemAPP(this.codEmpItem, this.codItem, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class DataPedidoItemVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVit";
  itemVit: PKTamanhoItemVit = new PKTamanhoItemVit();
  descricao: string = "";
  qtd: number = 0;
  precoUnitario: number = 0;
  desconto: number = 0;
  codCupomDesconto: number = 0;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
}


export class PKPagarMeTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagarMeTransacaoAPP";
  codPagarMeTransacao: number = 0;

  constructor()
  constructor(codPagarMeTransacao: number)
  constructor(codPagarMeTransacao?: number) {
    super();
    this.codPagarMeTransacao = codPagarMeTransacao || 0;
  }

  public getPK(): PKPagarMeTransacaoAPP {
    return new PKPagarMeTransacaoAPP(this.codPagarMeTransacao);
  }

  public equals(arg: PKPagarMeTransacaoAPP): boolean {
    return arg 
        && (arg.codPagarMeTransacao === this.codPagarMeTransacao)
    ;
  }
}


export class DataFrenetCotacaoServicoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoVit";
  ownHand: boolean = false;
  declaredValue: boolean = false;
  receiptNotification: boolean = false;
}


export class PKLiquidacaoParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKLiquidacaoParcelaAPP";
  codLiquidacaoParcela: number = 0;

  constructor()
  constructor(codLiquidacaoParcela: number)
  constructor(codLiquidacaoParcela?: number) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
  }

  public getPK(): PKLiquidacaoParcelaAPP {
    return new PKLiquidacaoParcelaAPP(this.codLiquidacaoParcela);
  }

  public equals(arg: PKLiquidacaoParcelaAPP): boolean {
    return arg 
        && (arg.codLiquidacaoParcela === this.codLiquidacaoParcela)
    ;
  }
}


export class PKClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKClienteAPP";
  codCliente: number = 0;
  codEmpresaCliente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
  }

  public getPK(): PKClienteAPP {
    return new PKClienteAPP(this.codEmpresaCliente, this.codCliente);
  }

  public equals(arg: PKClienteAPP): boolean {
    return arg 
        && (arg.codCliente === this.codCliente)
        && (arg.codEmpresaCliente === this.codEmpresaCliente)
    ;
  }
}


export class PKDependenteAPP extends PKClienteAPP {
  readonly jclass: string = "com.macle.app.vo.PKDependenteAPP";
  codDependente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number, codDependente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): PKDependenteAPP {
    return new PKDependenteAPP(this.codEmpresaCliente, this.codCliente, this.codDependente);
  }

  public equals(arg: PKDependenteAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codDependente === this.codDependente)
    ;
  }
}


export enum EStatusLiquidacaoAPP {
  NONE = 0,
  PENDENTE = 1,
  LIQUIDADO = 2,
  EXPIRADA = 3,
}

export namespace EStatusLiquidacaoAPP {
  export function toDisplay(arg: EStatusLiquidacaoAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pendente";
      case 2: return "Liquidado";
      case 3: return "Expirada";
      default: return "";
    }
  }

  export function enums(): EStatusLiquidacaoAPP[] {
    return [EStatusLiquidacaoAPP.NONE,EStatusLiquidacaoAPP.PENDENTE,EStatusLiquidacaoAPP.LIQUIDADO,EStatusLiquidacaoAPP.EXPIRADA];
  }
}


export class DataLiquidacaoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataLiquidacaoParcelaAPP";
  codEmpresa: number = 0;
  versaointegracao: EVersaoIntegracaoPagarmeAPP = EVersaoIntegracaoPagarmeAPP.NONE;
  dataHoraValidadePIX: string = "";
  urlBoleto: string = "";
  barcodeBoleto: string = "";
  lineBoleto: string = "";
  qrCodePIX: string = "";
  transactionId: string = "";
  qrCodePIXBase64: string = "";
  vencimento: string = "";
  enviadoSistema: boolean = false;
  listParcela: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  idPedido: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  hora: string = "";
  ativo: boolean = false;
  conta: PKContaAPP = new PKContaAPP();
  status: EStatusLiquidacaoAPP = EStatusLiquidacaoAPP.NONE;
  valor: number = 0;
  data: string = "";
}


export class DataNovoClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataNovoClienteAPP";
  nome: string = "";
  email: string = "";
  telefone: string = "";
  endereco: string = "";
  nascimento: string = "";
  complemento: string = "";
  cidade: string = "";
  bairro: string = "";
  numero: string = "";
  cpf: string = "";
  uf: string = "";
  cep: string = "";
}


export class FilterNCE extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterNCE";
  descricao: string = "";
  codTamanho: number = 0;
  refFornecedor: string = "";
  nivel4: number = 0;
  promo: boolean = false;
  nivel2: number = 0;
  nivel3: number = 0;
  nivel5: number = 0;
  nivel6: number = 0;
  nivel9: number = 0;
  nivel7: number = 0;
  nivel1: number = 0;
  nivel8: number = 0;
  exibeEstoqueApenasLoja: boolean = false;
  minFaixaPreco: number = 0;
  exibeItemZerado: boolean = false;
  codEmpresaLogin: number = 0;
  maxFaixaPreco: number = 0;
  codMarca: number = 0;
  public equals(arg: FilterNCE): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.codTamanho === this.codTamanho)
        && (arg.refFornecedor === this.refFornecedor)
        && (arg.nivel4 === this.nivel4)
        && (arg.promo === this.promo)
        && (arg.nivel2 === this.nivel2)
        && (arg.nivel3 === this.nivel3)
        && (arg.nivel5 === this.nivel5)
        && (arg.nivel6 === this.nivel6)
        && (arg.nivel9 === this.nivel9)
        && (arg.nivel7 === this.nivel7)
        && (arg.nivel1 === this.nivel1)
        && (arg.nivel8 === this.nivel8)
        && (arg.exibeEstoqueApenasLoja === this.exibeEstoqueApenasLoja)
        && (arg.minFaixaPreco === this.minFaixaPreco)
        && (arg.exibeItemZerado === this.exibeItemZerado)
        && (arg.codEmpresaLogin === this.codEmpresaLogin)
        && (arg.maxFaixaPreco === this.maxFaixaPreco)
        && (arg.codMarca === this.codMarca)
    ;
  }
}


export class DataMarcaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMarcaItemVit";
  codigoMarca: number = 0;
  descricaoMarca: string = "";
}


export class DataFrenetShippingServiceResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingServiceResponseVit";
  msg: string = "";
  carrier: string = "";
  shippingPrice: number = 0;
  carrierCode: string = "";
  serviceCode: string = "";
  deliveryTime: number = 0;
  serviceDescription: string = "";
  originalShippingPrice: number = 0;
  originalDeliveryTime: number = 0;
  error: boolean = false;
}


export class DataShareItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataShareItemAPP";
  imgNome: string = "";
  imgBase64: string = "";
  descItem: string = "";
}


export class DataPedidoClienteVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteVit";
  nome: string = "";
  cnpj: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  telefone: string = "";
  dataNascimento: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  senha: string = "";
  inscEstadual: string = "";
  codClienteVit: number = 0;
}


export class DataPackIdOrdersResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPackIdOrdersResultML";
  static_tags: string[] = [];
  id: number = 0;
}


export class DataPackIdResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPackIdResultML";
  status: string = "";
  orders: ArrayList<DataPackIdOrdersResultML> = new ArrayList<DataPackIdOrdersResultML>(DataPackIdOrdersResultML);
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  family_pack_id: number = 0;
  trash_pack_id: number = 0;
  status_detail: string = "";
  date_created: string = "";
  last_updated: string = "";
  shipment: DataPedidoShippingML = new DataPedidoShippingML();
  id: number = 0;
}


export class ConsumidorSiteResponseGetConsumidorV0APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV0APP";
  clienteLocalizado: boolean = false;
  urlConsultaVendedor: string = "";
  envioConfirmacao: string = "";
  chaveConfirmacao: number = 0;
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
  tipoConfirmacao: ETipoConfirmacaoConsumidorSiteAPP = ETipoConfirmacaoConsumidorSiteAPP.NONE;
  confirmado: boolean = false;
  token: string = "";
  vendedor: boolean = false;
}


export class ConsVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsVendedorAPP";
  nome: string = "";
  codVendedor: number = 0;
  listEmpresa: number[] = [];
  fotoBase64: string = "";
  whatsApp: number = 0;
  codEmpVendedor: number = 0;
}


export class PKVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendaAPP";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaAPP {
    return new PKVendaAPP(this.codVenda);
  }

  public equals(arg: PKVendaAPP): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class DataVendaVitrinePublicaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaVitrinePublicaAPP";
  clienteMacle: ArrayList<PKClienteMacleVitPub> = new ArrayList<PKClienteMacleVitPub>(PKClienteMacleVitPub);
}


export class DataFrenetEnderecoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEnderecoVit";
  city: string = "";
  zipCode: string = "";
  street: string = "";
  addressNumber: string = "";
  addressState: string = "";
  addressQuarter: string = "";
  postalBoxCode: string = "";
  enderecoCompleto: boolean = false;
  addressComplement: string = "";
  country: string = "";
}


export class DataFrenetPedidoEtiquetaClienteVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaClienteVit";
  email: string = "";
  phone: string = "";
  IE: string = "";
  document: string = "";
  cellphone: string = "";
  name: string = "";
  address: DataFrenetEnderecoVit = new DataFrenetEnderecoVit();
}


export class DataResultEmitePixPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultEmitePixPedido";
  valor: number = 0;
  dataHoraValidade: string = "";
  codMaclePagto: number = 0;
  pixCode: string = "";
  qrCodePix: string = "";
}


export class DataResultEmiteCartaoPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultEmiteCartaoPedido";
  nomeCartao: string = "";
  numeroCartao: string = "";
  codMaclePagto: number = 0;
  codSeguranca: string = "";
  anoValidade: number = 0;
  bandeira: string = "";
  mesValidade: number = 0;
  qtdParcelas: number = 0;
  cnpjTitularCartao: string = "";
}


export class PKCondVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKCondVendaAPP";
  codCondVenda: number = 0;
  codEmpresaCondVenda: number = 0;

  constructor()
  constructor(codEmpresaCondVenda: number, codCondVenda: number)
  constructor(codEmpresaCondVenda?: number, codCondVenda?: number) {
    super();
    this.codEmpresaCondVenda = codEmpresaCondVenda || 0;
    this.codCondVenda = codCondVenda || 0;
  }

  public getPK(): PKCondVendaAPP {
    return new PKCondVendaAPP(this.codEmpresaCondVenda, this.codCondVenda);
  }

  public equals(arg: PKCondVendaAPP): boolean {
    return arg 
        && (arg.codCondVenda === this.codCondVenda)
        && (arg.codEmpresaCondVenda === this.codEmpresaCondVenda)
    ;
  }
}


export class DataPedidoFormaPagamentoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoFormaPagamentoVit";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  cartao: DataResultEmiteCartaoPedido = new DataResultEmiteCartaoPedido();
  pix: DataResultEmitePixPedido = new DataResultEmitePixPedido();
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
  codMaclePagto: number = 0;
}


export enum EStatusPedidoPagamentoML {
  none = 0,
  rejected = 1,
  approved = 2,
  cancelled = 3,
  refunded = 4,
  in_mediation = 5,
  charged_back = 6,
}

export namespace EStatusPedidoPagamentoML {
  export function toDisplay(arg: EStatusPedidoPagamentoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagamento rejeitado";
      case 2: return "Pagamento aprovado";
      case 3: return "Pagamento cancelado";
      case 4: return "Pagamento devolvido";
      case 5: return "Pagamento em media&ccedil;&atilde;o";
      case 6: return "Pagamento em chargeback";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoPagamentoML[] {
    return [EStatusPedidoPagamentoML.none,EStatusPedidoPagamentoML.rejected,EStatusPedidoPagamentoML.approved,EStatusPedidoPagamentoML.cancelled,EStatusPedidoPagamentoML.refunded,EStatusPedidoPagamentoML.in_mediation,EStatusPedidoPagamentoML.charged_back];
  }
}


export class ConsImgItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsImgItemAPP";
  imagens: string[] = [];
}


export class DataVendaItemVitPub extends PKItemLojaVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVitPub";
  descricao: string = "";
  descricaoTamanho: string = "";
  codTamanho: number = 0;
  qtd: number = 0;
  imgPequenoBase64: string = "";
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  desconto: number = 0;
  itemControle: PKItemControleVit = new PKItemControleVit();
}


export class DataVendaItemAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaItemAPP";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  descricao: string = "";
  qtd: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  desconto: number = 0;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
}


export class DataEmiteCartaoDeCreditoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteCartaoDeCreditoPagarMeAPP";
  nome: string = "";
  email: string = "";
  telefone: string = "";
  endereco: string = "";
  dadosResumidos: boolean = false;
  codigoSegurancaCartao: string = "";
  mesValidadeCartao: number = 0;
  anoValidadeCartao: number = 0;
  enderecoComplemento: string = "";
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  enderecoCEP: string = "";
  enderecoCidade: string = "";
  telefoneDDD: string = "";
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoEstado: string = "";
  cardHash: string = "";
  valorFrete: number = 0;
  nomeCartao: string = "";
  numeroCartao: string = "";
  qtdParcela: number = 0;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  valor: number = 0;
}


export class DataVendaEnderecoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEnderecoAPP";
  endereco: DataEndereco = new DataEndereco();
}


export class DataParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataParametrosAPP";
  logoBase64: string = "";
  telefone: string = "";
  pctDescontoBoletoAPP: number = 0;
  appVitrinePublica: boolean = false;
  qtdMaxParcelaAPP: number = 0;
  valorMinParcelaAPP: number = 0;
  taxaBoletoAbaixoDeAPP: number = 0;
  habilitaBoletoCompraAPP: boolean = false;
  habilitaEntregaCompraAPP: boolean = false;
  habilitaCondicionalAPP: boolean = false;
  habilitaPIXParcelaAPP: boolean = false;
  habilitaPIXCompraAPP: boolean = false;
  cepOrigemSigepAPP: number = 0;
  habilitaBoletoParcelaAPP: boolean = false;
  habilitaComprasAPP: boolean = false;
  pctDescontoCompraPIXAPP: number = 0;
  habilitaCartaoCompraAPP: boolean = false;
  servidorConsulta: string = "";
  codContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  whatsApp: number = 0;
  idSellerZoop: string = "";
  chaveAPIPagarMe: string = "";
  dataReferencia: string = "";
  tokenFrenet: string = "";
  fantasia: string = "";
  ativo: boolean = false;
  urlAPP: string = "";
  CNPJ: string = "";
  lconta: ArrayList<DataContaAPP> = new ArrayList<DataContaAPP>(DataContaAPP);
  macleID: string = "";
  codEmpresaContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  distanciaEntregaGratisCompraAPP: number = 0;
  valorTaxaEntregaCompraAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
  valorMinParcelaCrediarioAPP: number = 0;
  habilitaLiquidacaoParcelaAPP: boolean = false;
  pctDescontoCreditoCartaoAPP: number = 0;
  qtdMaxParcelaCrediarioAPP: number = 0;
  habilitaRetiradaLojaCompraAPP: boolean = false;
  valorFreteGratisCorreioAPP: number = 0;
  chaveCriptografiaPagarMe: string = "";
  habilitaCrediarioCompraAPP: boolean = false;
  habilitaConsultaEstoqueVendedor: boolean = false;
  diasValidadeLinkVendedorAPP: number = 0;
  habilitaEntregaCorreiosAPP: boolean = false;
  valorTaxaEntregaCondicionalAPP: number = 0;
  tipoFreteGratisCorreioAPP: ETipoFrete = ETipoFrete.NONE;
  empresaRetirataMercadoriaAPP: string = "";
  distanciaMaximaEntregaCondicionalAPP: number = 0;
  habilitaSomenteConsultaParcelaAPP: boolean = false;
  codEmpresaLiquidacaoParcelaAplicativo: number = 0;
  valorTaxaEntregaCompraAbaixoDeAPP: number = 0;
  taxaBoletoLiquidacaoParcelaAplicativo: number = 0;
  habilitaVisMensagemCompraWhatsAPP: boolean = false;
}


export class DataPedidoEntregaVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVit";
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
}


export class PKDocVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKDocVendaAPP";
  codEmpresa: number = 0;
  serie: number = 0;
  numero: number = 0;

  constructor()
  constructor(codEmpresa: number, serie: number, numero: number)
  constructor(codEmpresa?: number, serie?: number, numero?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.serie = serie || 0;
    this.numero = numero || 0;
  }

  public getPK(): PKDocVendaAPP {
    return new PKDocVendaAPP(this.codEmpresa, this.serie, this.numero);
  }

  public equals(arg: PKDocVendaAPP): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.serie === this.serie)
        && (arg.numero === this.numero)
    ;
  }
}


export class DataVendaVitPub extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVitPub";
  hora: string = "";
  valor: number = 0;
  listItem: ArrayList<DataVendaItemVitPub> = new ArrayList<DataVendaItemVitPub>(DataVendaItemVitPub);
  codEmpresaVenda: number = 0;
  codVitrineVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  desconto: number = 0;
  data: string = "";
}


export class DataSendLiquidaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaAPP";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataPagamento: string = "";
  dataEmissaoBoleto: string = "";
  idTransacao: number = 0;
  valorPago: number = 0;
  idPagamento: number = 0;
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class DataFrenetCotacaoServicoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoResponseVit";
  msg: string = "";
  carrier: string = "";
  shippingServiceCode: string = "";
  shippingServiceName: string = "";
  shippingPrice: number = 0;
  carrierCode: string = "";
  deliveryTime: number = 0;
  shippingCompetitorPrice: number = 0;
  platformShippingPrice: number = 0;
  error: boolean = false;
  services: DataFrenetCotacaoServicoVit = new DataFrenetCotacaoServicoVit();
}


export class ConsLojaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojaAPP";
  cnpj: string = "";
  codEmpresa: number = 0;
  fantasia: string = "";
  logradouro: string = "";
  cidade: string = "";
  bairro: string = "";
  CEP: number = 0;
  UF: string = "";
  numero: string = "";
}


export class ConsLojasComVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojasComVendedorAPP";
  listLoja: ArrayList<ConsLojaAPP> = new ArrayList<ConsLojaAPP>(ConsLojaAPP);
  listVendedor: ArrayList<ConsVendedorAPP> = new ArrayList<ConsVendedorAPP>(ConsVendedorAPP);
}


export enum ETipoPrecoVendaAPP {
  NONE = 0,
  PRCITEM = 1,
  PRCEMPRESA = 2,
  PRCTAMANHO = 3,
  PRCEMPTAM = 4,
}

export namespace ETipoPrecoVendaAPP {
  export function toDisplay(arg: ETipoPrecoVendaAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pre&ccedil;o do item";
      case 2: return "Pre&ccedil;o por empresa";
      case 3: return "Pre&ccedil;o por tamanho";
      case 4: return "Prc.empresa e tamanho";
      default: return "";
    }
  }

  export function enums(): ETipoPrecoVendaAPP[] {
    return [ETipoPrecoVendaAPP.NONE,ETipoPrecoVendaAPP.PRCITEM,ETipoPrecoVendaAPP.PRCEMPRESA,ETipoPrecoVendaAPP.PRCTAMANHO,ETipoPrecoVendaAPP.PRCEMPTAM];
  }
}


export class DataFrenetPedidoEtiquetaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemVit";
  width: number = 0;
  height: number = 0;
  weight: number = 0;
  fragile: boolean = false;
  price: number = 0;
  sku: string = "";
  orderId: string = "";
  itemId: string = "";
  productType: string = "";
  quantity: number = 0;
  productName: string = "";
  productId: string = "";
  category: string = "";
  productOptions: string = "";
  length: number = 0;
}


export class DataFrenetPedidoEtiquetaNotaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaNotaVit";
  series: string = "";
  CFOP: string = "";
  value: number = 0;
  key: string = "";
  number: string = "";
  date: string = "";
}


export class DataFrenetPedidoEtiquetaOrdemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaOrdemVit";
  to: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  items: ArrayList<DataFrenetPedidoEtiquetaItemVit> = new ArrayList<DataFrenetPedidoEtiquetaItemVit>(DataFrenetPedidoEtiquetaItemVit);
  useFrenetRegistration: boolean = false;
  created: string = "";
  invoice: DataFrenetPedidoEtiquetaNotaVit = new DataFrenetPedidoEtiquetaNotaVit();
  value: number = 0;
  id: string = "";
  from: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
}


export class DataPedidoItemVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVitPub";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  descricao: string = "";
  qtd: number = 0;
  precoUnitario: number = 0;
  desconto: number = 0;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
}


export class DataPedidoEnderecoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEnderecoVit";
  endereco: DataEndereco = new DataEndereco();
}


export class DataPedidoLojaPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoLojaPub";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  horaUltimoUpdate: string = "";
  dataUltimoUpdate: string = "";
  nroetiquetasigep: string = "";
  dataCancelamento: string = "";
}


export class DataPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVitPub";
  enviadoSistema: boolean = false;
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  hora: string = "";
  valor: number = 0;
  listItem: ArrayList<DataPedidoItemVitPub> = new ArrayList<DataPedidoItemVitPub>(DataPedidoItemVitPub);
  listEntrega: ArrayList<DataPedidoEntregaVitPub> = new ArrayList<DataPedidoEntregaVitPub>(DataPedidoEntregaVitPub);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  desconto: number = 0;
  acrescimo: number = 0;
  listPedidoLoja: ArrayList<DataPedidoLojaPub> = new ArrayList<DataPedidoLojaPub>(DataPedidoLojaPub);
  codEmpresaPedido: number = 0;
  data: string = "";
}


export class DataRetirarLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRetirarLojaVitrinePubAPP";
  codClienteMacle: number = 0;
  fantasia: string = "";
  lojasComVendedor: ConsLojasComVendedorAPP = new ConsLojasComVendedorAPP();
}


export class ConsParcelaLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsParcelaLiquidacaoAPP";
  numeroTotalParcelas: number = 0;
  numeroParcela: number = 0;
  dataVencimento: string = "";
  dataEmissao: string = "";
  documentoOrigem: string = "";
  saldo: number = 0;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  vencida: boolean = false;
  parcela: PKParcelaAPP = new PKParcelaAPP();
}


export class DataCepAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCepAPP";
  logradouro: string = "";
  cidade: string = "";
  codCEP: number = 0;
  bairro: string = "";
  codUF: string = "";
}


export class ConsClienteAPP extends PKDependenteAPP {
  readonly jclass: string = "com.macle.app.vo.ConsClienteAPP";
  nome: string = "";
  cnpj: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  pontos: number = 0;
  telefone: string = "";
  qtdItens: number = 0;
  qtdParcAtivas: number = 0;
  qtdParcVencida: number = 0;
  regraMinimaAtiva: boolean = false;
  dataNascimento: string = "";
  limiteCredito: number = 0;
  clienteNovo: boolean = false;
  endereco: DataEndereco = new DataEndereco();
  dadosResumidos: boolean = false;
  crediarioLiberado: boolean = false;
  totalLimiteCredito: number = 0;
}


export class DataFrenetEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEtiquetaErroVit";
  code: number = 0;
  message: string = "";
}


export class DataFrenetPedidoEtiquetaVolumeVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVolumeVit";
  width: number = 0;
  height: number = 0;
  weight: number = 0;
  price: number = 0;
  declaredValue: number = 0;
  volumeId: number = 0;
  length: number = 0;
}


export class DataFrenetPedidoEtiquetaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVit";
  volumes: DataFrenetPedidoEtiquetaVolumeVit = new DataFrenetPedidoEtiquetaVolumeVit();
  quotation: DataFrenetCotacaoServicoResponseVit = new DataFrenetCotacaoServicoResponseVit();
  branchCode: string = "";
  shipmentId: number = 0;
  shipmentStatus: number = 0;
  statusNotificationUrl: string = "";
  trackingNotificationUrl: string = "";
  order: DataFrenetPedidoEtiquetaOrdemVit = new DataFrenetPedidoEtiquetaOrdemVit();
}


export class DataDocVendaItemAPP extends PKTamanhoItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaItemAPP";
  imagem: string = "";
  descricao: string = "";
  descricaoTamanho: string = "";
  qtd: number = 0;
}


export class DataDocVendaAPP extends PKDocVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaAPP";
  dataEmissao: string = "";
  hora: string = "";
  itens: ArrayList<DataDocVendaItemAPP> = new ArrayList<DataDocVendaItemAPP>(DataDocVendaItemAPP);
}


export class PKZoopTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKZoopTransacaoAPP";
  codZoopTransacao: number = 0;

  constructor()
  constructor(codZoopTransacao: number)
  constructor(codZoopTransacao?: number) {
    super();
    this.codZoopTransacao = codZoopTransacao || 0;
  }

  public getPK(): PKZoopTransacaoAPP {
    return new PKZoopTransacaoAPP(this.codZoopTransacao);
  }

  public equals(arg: PKZoopTransacaoAPP): boolean {
    return arg 
        && (arg.codZoopTransacao === this.codZoopTransacao)
    ;
  }
}


export class DataZoopTransacaoAPP extends PKZoopTransacaoAPP {
  readonly jclass: string = "com.macle.app.vo.DataZoopTransacaoAPP";
  idPedido: string = "";
  idCobranca: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  hora: string = "";
  idTransacao: number = 0;
  jsonTransacao: string = "";
  data: string = "";
}


export class DataFreteVitrineServico extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineServico";
  nome: string = "";
  indisponivel: boolean = false;
  codigo: string = "";
  diasEntrega: number = 0;
  valorEntrega: number = 0;
}


export class DataFreteVitrineOperadora extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineOperadora";
  nome: string = "";
  codigo: string = "";
  servicos: ArrayList<DataFreteVitrineServico> = new ArrayList<DataFreteVitrineServico>(DataFreteVitrineServico);
}


export class DataSendLiquidaParcelaPagarmeV5APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaPagarmeV5APP";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  idPedido: string = "";
  dataPagamento: string = "";
  idCobranca: string = "";
  dataEmissaoBoleto: string = "";
  valorPago: number = 0;
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class PKPagamentoPIXAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoPIXAPP";
  codPagamentoPIX: number = 0;

  constructor()
  constructor(codPagamentoPIX: number)
  constructor(codPagamentoPIX?: number) {
    super();
    this.codPagamentoPIX = codPagamentoPIX || 0;
  }

  public getPK(): PKPagamentoPIXAPP {
    return new PKPagamentoPIXAPP(this.codPagamentoPIX);
  }

  public equals(arg: PKPagamentoPIXAPP): boolean {
    return arg 
        && (arg.codPagamentoPIX === this.codPagamentoPIX)
    ;
  }
}


export class DataPagamentoPIXAPP extends PKPagamentoPIXAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoPIXAPP";
  codEmpresa: number = 0;
  liquidacaoParcela: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
  dataHoraValidoAte: string = "";
  transactionId: string = "";
  idPedido: string = "";
  idCobranca: string = "";
  conta: PKContaAPP = new PKContaAPP();
  pago: boolean = false;
  venda: PKVendaAPP = new PKVendaAPP();
}


export class DataFrenetCotacaoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoResponseVit";
  shippingServiceCodeSelect: string = "";
  sessionId: string = "";
  quotations: ArrayList<DataFrenetCotacaoServicoResponseVit> = new ArrayList<DataFrenetCotacaoServicoResponseVit>(DataFrenetCotacaoServicoResponseVit);
}


export class DataVendaEntregaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEntregaAPP";
  codClienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
}


export class DataFrenetPedidoEtiquetaItemResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemResponseVit";
  errors: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
  orderId: string = "";
  trackingUrl: string = "";
  labelUrl: string = "";
  validThrough: string = "";
  shipmentId: number = 0;
  shipmentStatus: number = 0;
  declarationUrl: string = "";
  receiptNotificationUrl: string = "";
}


export class DataSendStatusPedido extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendStatusPedido";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  venda: PKPedidoVit = new PKPedidoVit();
}


export class DataPrecoVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataPrecoVendaAPP";
  promocao: boolean = false;
  codEmpresa: number = 0;
  dataFimPromo: string = "";
  dataAlter: string = "";
  precoVenda: number = 0;
  precoAlter: number = 0;
  dataIniPromo: string = "";
  vlrPromo: number = 0;
  congelado: boolean = false;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
}


export class DataResultEmiteBoletoZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteBoletoZoopAPP";
  urlBoleto: string = "";
  barcodeBoleto: string = "";
  pkTransacao: PKZoopTransacaoAPP = new PKZoopTransacaoAPP();
  vencimentoBoleto: string = "";
  valorBoletoSemTaxa: number = 0;
  valorBoleto: number = 0;
}


export class DataPedidoAntFraudeVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoAntFraudeVit";
  ip: string = "";
  koinSessionID: string = "";
}


export class DataEntregaLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaLojaVitrinePubAPP";
  codClienteMacle: number = 0;
  distanciaKM: number = 0;
  nomeLoja: string = "";
  distanciaEntregaGratisCompraAPP: number = 0;
  valorTaxaEntregaCompraAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
}


export class ConsumidorSiteResponseChaveConfirmacaoValida extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseChaveConfirmacaoValida";
  chaveConfirmacaoValida: boolean = false;
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
  token: string = "";
}


export class DataUrlParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataUrlParametrosAPP";
  codVitrine: number = 0;
  codVendedor: number = 0;
  codEmpVendedor: number = 0;
  itens: string[] = [];
  codEmpresaVenda: number = 0;
}


export class DataDadosClienteEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataDadosClienteEmissaoBoletoAPP";
  nome: string = "";
  email: string = "";
  telefone: string = "";
  endereco: string = "";
  enderecoCEP: string = "";
  enderecoCidade: string = "";
  telefoneDDD: string = "";
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoEstado: string = "";
}


export class FilterLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterLiquidacaoAPP";
}


export enum EStatusPedidoML {
  NONE = 0,
  confirmed = 1,
  payment_required = 2,
  payment_in_process = 3,
  partially_paid = 4,
  paid = 5,
  partially_refunded = 6,
  pending_cancel = 7,
  cancelled = 8,
  invalid = 9,
}

export namespace EStatusPedidoML {
  export function toDisplay(arg: EStatusPedidoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Status inicial de uma order; ainda sem ter sido paga.";
      case 2: return "O pagamento da order deve ter sido confirmado para exibir as informa&ccedil;&otilde;es do usu&aacute;rio.";
      case 3: return "H&aacute; um pagamento relacionado à order, mais ainda n&atilde;o foi aprovado.";
      case 4: return "A order tem um pagamento associado creditado, por&eacute;m, insuficiente.";
      case 5: return "A order tem um pagamento associado aprovado.";
      case 6: return "A order tem devolu&ccedil;&otilde;es paciais de seus pagamentos.";
      case 7: return "Quando a order foi cancelada mas temos dificultdade para devolver o pagamento.";
      case 8: return "Por alguma raz&atilde;o, a order n&atilde;o foi completada.";
      case 9: return "A order foi invalidada por vir de um comprador malicioso.";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoML[] {
    return [EStatusPedidoML.NONE,EStatusPedidoML.confirmed,EStatusPedidoML.payment_required,EStatusPedidoML.payment_in_process,EStatusPedidoML.partially_paid,EStatusPedidoML.paid,EStatusPedidoML.partially_refunded,EStatusPedidoML.pending_cancel,EStatusPedidoML.cancelled,EStatusPedidoML.invalid];
  }
}


export class DataParametrosVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataParametrosVit";
  googleVerificacao: string = "";
  pixelID: string = "";
  gtmID: string = "";
  googleAnalytics: string = "";
  habilitaPixel: boolean = false;
  habilitaGTM: boolean = false;

  constructor()
  constructor(habilitaPixel: boolean, pixelID: string, habilitaGTM: boolean, gtmID: string, googleVerificacao: string, googleAnalytics: string)
  constructor(habilitaPixel?: boolean, pixelID?: string, habilitaGTM?: boolean, gtmID?: string, googleVerificacao?: string, googleAnalytics?: string) {
    super();
    this.habilitaPixel = habilitaPixel || false;
    this.pixelID = pixelID || "";
    this.habilitaGTM = habilitaGTM || false;
    this.gtmID = gtmID || "";
    this.googleVerificacao = googleVerificacao || "";
    this.googleAnalytics = googleAnalytics || "";
  }

  public getPK(): DataParametrosVit {
    return new DataParametrosVit(this.habilitaPixel, this.pixelID, this.habilitaGTM, this.gtmID, this.googleVerificacao, this.googleAnalytics);
  }

  public equals(arg: DataParametrosVit): boolean {
    return arg 
        && (arg.googleVerificacao === this.googleVerificacao)
        && (arg.pixelID === this.pixelID)
        && (arg.gtmID === this.gtmID)
        && (arg.googleAnalytics === this.googleAnalytics)
        && (arg.habilitaPixel === this.habilitaPixel)
        && (arg.habilitaGTM === this.habilitaGTM)
    ;
  }
}


export class PKPagamentoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoParcelaAPP";
  idPagarmeV5: string = "";
  id: number = 0;

  constructor()
  constructor(codLiquidacaoParcela: number, id: number, idPagarmeV5: string)
  constructor(codLiquidacaoParcela?: number, id?: number, idPagarmeV5?: string) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
    this.id = id || 0;
    this.idPagarmeV5 = idPagarmeV5 || "";
  }

  public getPK(): PKPagamentoParcelaAPP {
    return new PKPagamentoParcelaAPP(this.codLiquidacaoParcela, this.id, this.idPagarmeV5);
  }

  public equals(arg: PKPagamentoParcelaAPP): boolean {
    return arg && super.equals(arg)
        && (arg.idPagarmeV5 === this.idPagarmeV5)
        && (arg.id === this.id)
    ;
  }
}


export class DataVendaFormaPagamentoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaFormaPagamentoAPP";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  cartao: DataResultEmiteCartaoPedido = new DataResultEmiteCartaoPedido();
  pix: DataResultEmitePixPedido = new DataResultEmitePixPedido();
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
  codMaclePagto: number = 0;
}


export class ConsumidorSiteResponseGetConsumidorV1APP extends ConsumidorSiteResponseGetConsumidorV0APP {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV1APP";
  acessoAppPagtoParc: boolean = false;
}


export class ConsCondVendaAPP extends PKCondVendaAPP {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAPP";
  pctDesc: number = 0;
  descricao: string = "";
  forceVlrParc: number = 0;
  diaEntreParc: number = 0;
  diaPrimeiraParc: number = 0;
  numParcelas: number = 0;
  pctEntrada: number = 0;
  arredond: EArredondPrc = EArredondPrc.NONE;
  diaVencto: number = 0;
  pctAcres: number = 0;
  dataPrimParc: string = "";
  trintaDiasDireto: boolean = false;
}


export class ConsCondVendaAuxAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAuxAPP";
  listCondVenda: ArrayList<ConsCondVendaAPP> = new ArrayList<ConsCondVendaAPP>(ConsCondVendaAPP);
}


export class ConsCorItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCorItemAPP";
  nome: string = "";
  imagem: string = "";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, nome: string, imagem: string)
  constructor(codEmpItem?: number, codItem?: number, nome?: string, imagem?: string) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.nome = nome || "";
    this.imagem = imagem || "";
  }

  public getPK(): ConsCorItemAPP {
    return new ConsCorItemAPP(this.codEmpItem, this.codItem, this.nome, this.imagem);
  }

  public equals(arg: ConsCorItemAPP): boolean {
    return arg 
        && (arg.nome === this.nome)
        && (arg.imagem === this.imagem)
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export class DataEmiteBoletoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoPagarMeAPP";
  nome: string = "";
  email: string = "";
  telefone: string = "";
  endereco: string = "";
  dadosResumidos: boolean = false;
  enderecoCEP: string = "";
  liquidacao: DataLiquidacaoParcelaAPP = new DataLiquidacaoParcelaAPP();
  enderecoCidade: string = "";
  telefoneDDD: string = "";
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoEstado: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  valor: number = 0;
}


export class DataFrenetPedidoEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaErroVit";
  details: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
  message: string = "";
}


export class DataFrenetPedidoEtiquetaResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaResponseVit";
  items: ArrayList<DataFrenetPedidoEtiquetaItemResponseVit> = new ArrayList<DataFrenetPedidoEtiquetaItemResponseVit>(DataFrenetPedidoEtiquetaItemResponseVit);
  statusBatch: string = "";
  error: DataFrenetPedidoEtiquetaErroVit = new DataFrenetPedidoEtiquetaErroVit();
}


export class ConsTamanhoItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsTamanhoItemAPP";
  descricao: string = "";
  disponivel: boolean = false;
  codTamanho: number = 0;

  constructor()
  constructor(codTamanho: number, descricao: string, disponivel: boolean)
  constructor(codTamanho?: number, descricao?: string, disponivel?: boolean) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.disponivel = disponivel || false;
  }

  public getPK(): ConsTamanhoItemAPP {
    return new ConsTamanhoItemAPP(this.codTamanho, this.descricao, this.disponivel);
  }

  public equals(arg: ConsTamanhoItemAPP): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.disponivel === this.disponivel)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class ConsItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsItemAPP";
  tipo: string = "";
  marca: string = "";
  imagens: string[] = [];
  cores: ArrayList<ConsCorItemAPP> = new ArrayList<ConsCorItemAPP>(ConsCorItemAPP);
  precos: ArrayList<DataPrecoVendaAPP> = new ArrayList<DataPrecoVendaAPP>(DataPrecoVendaAPP);
  promocao: boolean = false;
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  preco: number = 0;
  descricao: string = "";
  precoTabela: number = 0;
  tipoPreco: ETipoPrecoVendaAPP = ETipoPrecoVendaAPP.NONE;
  tamanhos: ArrayList<ConsTamanhoItemAPP> = new ArrayList<ConsTamanhoItemAPP>(ConsTamanhoItemAPP);
  refFornecedor: string = "";
}


export class DataSendLiquidaParcelaZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaZoopAPP";
  codEmpresa: number = 0;
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataPagamento: string = "";
  conta: PKContaAPP = new PKContaAPP();
  dataEmissaoBoleto: string = "";
  valorPago: number = 0;
  transactionID: string = "";
  idTransacaoPIX: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  horaPagamento: string = "";
}


export class DataFreteVitrine extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrine";
  codigo: string = "";
  operadoras: ArrayList<DataFreteVitrineOperadora> = new ArrayList<DataFreteVitrineOperadora>(DataFreteVitrineOperadora);
}


export class DataEmiteBoletoVendaPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoVendaPagarMeAPP";
  nome: string = "";
  email: string = "";
  telefone: string = "";
  endereco: string = "";
  dadosResumidos: boolean = false;
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  enderecoCEP: string = "";
  enderecoCidade: string = "";
  telefoneDDD: string = "";
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoEstado: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  valor: number = 0;
}


export class DataCanSelectParcelaApp extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCanSelectParcelaApp";
  marcadas: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  parcela: PKParcelaAPP = new PKParcelaAPP();
}


export class DataPagamentoParcelaAPP extends PKPagamentoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoParcelaAPP";
  dataPagamento: string = "";
  dataCriacao: string = "";
  valor: number = 0;
}


export class DataFrenetShippingResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingResponseVit";
  shippingSevicesArray: ArrayList<DataFrenetShippingServiceResponseVit> = new ArrayList<DataFrenetShippingServiceResponseVit>(DataFrenetShippingServiceResponseVit);
}


export class DataTipoItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataTipoItemVit";
  descricaoTipo: string = "";
  codigoTipo: number = 0;
}


export class DataRespCanSelect extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRespCanSelect";
  canSelectText: string = "";
  canSelect: boolean = false;
}


export class DataVendaClienteAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaClienteAPP";
  nome: string = "";
  cnpj: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  telefone: string = "";
  dataNascimento: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  dadosResumido: boolean = false;
  inscEstadual: string = "";
}


export class DataVendaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaAPP";
  enviadoSistema: boolean = false;
  formaPagamento: DataVendaFormaPagamentoAPP = new DataVendaFormaPagamentoAPP();
  cliente: DataVendaClienteAPP = new DataVendaClienteAPP();
  hora: string = "";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  valor: number = 0;
  idPedidoEntregaML: number = 0;
  listItem: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  codEmpresaVenda: number = 0;
  listEntrega: ArrayList<DataVendaEntregaAPP> = new ArrayList<DataVendaEntregaAPP>(DataVendaEntregaAPP);
  enviadoVitrine: boolean = false;
  pkVendaVit: PKVendaVit = new PKVendaVit();
  codVitrineVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataVendaEnderecoAPP = new DataVendaEnderecoAPP();
  idPedidoML: number = 0;
  desconto: number = 0;
  vendaFinalizada: boolean = false;
  data: string = "";
}


export class ConsItemVitEstoque extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.ConsItemVitEstoque";
  descricao: string = "";
  codTamanho: number = 0;
  qtd: number = 0;
  ordem: number = 0;

  constructor()
  constructor(codTamanho: number, descricao: string, ordem: number, qtd: number)
  constructor(codTamanho?: number, descricao?: string, ordem?: number, qtd?: number) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.ordem = ordem || 0;
    this.qtd = qtd || 0;
  }

  public getPK(): ConsItemVitEstoque {
    return new ConsItemVitEstoque(this.codTamanho, this.descricao, this.ordem, this.qtd);
  }

  public equals(arg: ConsItemVitEstoque): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.codTamanho === this.codTamanho)
        && (arg.qtd === this.qtd)
        && (arg.ordem === this.ordem)
    ;
  }
}


export class DataResultEmitePixZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmitePixZoopAPP";
  qr_code: string = "";
  dataHoraValidade: string = "";
  qr_code_url: string = "";
  valorPIX: number = 0;
  pkLiquidacao: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
}


export class DataMedidaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMedidaItemVit";
  comprimentoCM: number = 0;
  pesoGramas: number = 0;
  alturaCM: number = 0;
  larguraCM: number = 0;
}


export class DataPedidoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVit";
  enviadoSistema: boolean = false;
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  hora: string = "";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  valor: number = 0;
  listItem: ArrayList<DataPedidoItemVit> = new ArrayList<DataPedidoItemVit>(DataPedidoItemVit);
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  idPedidoML: number = 0;
  desconto: number = 0;
  horaUltimoUpdate: string = "";
  dataUltimoUpdate: string = "";
  nroetiquetasigep: string = "";
  dataCancelamento: string = "";
  entrega: DataPedidoEntregaVit = new DataPedidoEntregaVit();
  acrescimo: number = 0;
  pedidoML: DataPedidoResultML = new DataPedidoResultML();
  cupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
  antiFraude: DataPedidoAntFraudeVit = new DataPedidoAntFraudeVit();
  codEmpresaPedido: number = 0;
  data: string = "";
}


export class DataFrenetShippingItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingItemVit";
  width: number = 0;
  height: number = 0;
  weight: number = 0;
  quantity: number = 0;
  category: string = "";
  SKU: string = "";
  length: number = 0;
}


export class DataFrenetShippingVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingVit";
  shippingServiceCode: string = "";
  shippingItemArray: ArrayList<DataFrenetShippingItemVit> = new ArrayList<DataFrenetShippingItemVit>(DataFrenetShippingItemVit);
  shipmentInvoiceValue: number = 0;
  recipientCountry: string = "";
  recipientCEP: string = "";
  sellerCEP: string = "";
}


export class DataShareAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataShareAPP";
  url: string = "";
  itens: ArrayList<DataShareItemAPP> = new ArrayList<DataShareItemAPP>(DataShareItemAPP);
}


export enum EStatusProdutoML {
  NONE = 0,
  active = 1,
  closed = 2,
  paused = 3,
  under_review = 4,
}

export namespace EStatusProdutoML {
  export function toDisplay(arg: EStatusProdutoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Ativo";
      case 2: return "Inativo";
      case 3: return "Pausado";
      case 4: return "Em revis&atilde;o";
      default: return "";
    }
  }

  export function enums(): EStatusProdutoML[] {
    return [EStatusProdutoML.NONE,EStatusProdutoML.active,EStatusProdutoML.closed,EStatusProdutoML.paused,EStatusProdutoML.under_review];
  }
}


export class PKItemHashtagVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemHashtagVit";
  codHashtag: number = 0;

  constructor()
  constructor(codHashtag: number)
  constructor(codHashtag?: number) {
    super();
    this.codHashtag = codHashtag || 0;
  }

  public getPK(): PKItemHashtagVit {
    return new PKItemHashtagVit(this.codHashtag);
  }

  public equals(arg: PKItemHashtagVit): boolean {
    return arg 
        && (arg.codHashtag === this.codHashtag)
    ;
  }
}


export class DataConsultaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataConsultaParcelaAPP";
  dadosCliente: DataDadosClienteEmissaoBoletoAPP = new DataDadosClienteEmissaoBoletoAPP();
  listParcelas: ArrayList<ConsParcelaLiquidacaoAPP> = new ArrayList<ConsParcelaLiquidacaoAPP>(ConsParcelaLiquidacaoAPP);
  listBoletos: ArrayList<DataLiquidacaoParcelaAPP> = new ArrayList<DataLiquidacaoParcelaAPP>(DataLiquidacaoParcelaAPP);
  cliente: PKDependenteAPP = new PKDependenteAPP();
}


export class DataItemHashTagVit extends PKItemHashtagVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataItemHashTagVit";
  hashtag: string = "";
}


